import type { JSX, ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const FormSection = ({
  label,
  children,
  error = false,
  id,
  contentClassName,
  action,
}: {
  label?: string;
  children: JSX.Element;
  error?: boolean;
  id?: string;
  contentClassName?: string;
  action?: ReactNode;
}) => {
  return (
    <section className="w-full space-y-4 md:space-y-6" id={id}>
      {(label || action) && (
        <div className="flex flex-wrap items-center justify-between gap-2">
          {label && <h2 className="text-2xl">{label}</h2>}
          {action}
        </div>
      )}
      <Card
        className={cn("border-transparent bg-brand-grey1", {
          "border-brand-red": error,
        })}
      >
        <CardContent className={cn("p-4 md:p-6", contentClassName)}>
          {children}
        </CardContent>
      </Card>
    </section>
  );
};
